/* =========================================================================
   London Repair Outlet, spotlight glow.

   The card highlight is CSS: an amber ring plus a radial glow that appears on
   hover and on focus-within. This file does one optional extra, which is move
   the glow's origin to follow the pointer, so the light behaves like light
   rather than like a static gradient.

   Everything degrades cleanly:
     - with this file absent, the glow still works, centred at the card top
     - on touch devices the listener is never attached, because there is no
       pointer to follow and it would cost work for nothing
     - under prefers-reduced-motion the tracking is skipped entirely

   Written against pointer events with a rAF gate, so a grid of 48 cards costs
   one style write per frame at most, not one per mouse move.
   ========================================================================= */

(function () {
  'use strict';

  if (window.__lroGlowLoaded) return;
  window.__lroGlowLoaded = true;

  var SELECTOR = '.product-grid__card';
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!fine || !fine.matches) return;
  if (calm && calm.matches) return;

  var pending = null;
  var queued = false;

  function paint() {
    queued = false;
    if (!pending) return;
    var el = pending.el;
    var rect = el.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    var x = ((pending.x - rect.left) / rect.width) * 100;
    var y = ((pending.y - rect.top) / rect.height) * 100;
    /* Clamp so a fast exit cannot park the glow far outside the card. */
    el.style.setProperty('--lro-glow-x', Math.max(-20, Math.min(120, x)).toFixed(1) + '%');
    el.style.setProperty('--lro-glow-y', Math.max(-20, Math.min(120, y)).toFixed(1) + '%');
  }

  function onMove(e) {
    var el = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!el) return;
    pending = { el: el, x: e.clientX, y: e.clientY };
    if (!queued) {
      queued = true;
      window.requestAnimationFrame(paint);
    }
  }

  function onLeave(e) {
    var el = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!el) return;
    /* Reset so the next hover starts from the top edge rather than wherever
       the pointer happened to leave. */
    el.style.removeProperty('--lro-glow-x');
    el.style.removeProperty('--lro-glow-y');
  }

  /* Delegated at the document, so cards added later by the filter system or
     the Section Rendering API are covered without re-binding. */
  document.addEventListener('pointermove', onMove, { passive: true });
  document.addEventListener('pointerout', onLeave, { passive: true });
})();
